module.exports = __webpack_public_path__ + "img/icon-linkedin.26428cdc272b938ca5c0a738a2aad8dd.svg";